import { defineComponent as _defineComponent } from 'vue'
import SvgIcon from '../common/SvgIcon.vue';
import { useBasicStore } from '@/stores/basic';
import { useRoomStore } from '@/stores/room';
import { storeToRefs } from 'pinia';
import { ref, onMounted, onUnmounted, Ref, ComputedRef, watch, nextTick, computed } from 'vue';
import { Message } from 'element-ui';
import {WARNING_MESSAGE,MESSAGE_DURATION} from "@/constants/message";
import Foom from './voteFoom/foom.vue';
import ResuliList from './voteFoom/resuliList.vue';
import Publish from './voteFoom/publish.vue';
import {  getVoteList, deleteVote, editStatus,exportVote} from '@/api/vote';
import exportAnalysisHooks from '@/putils/download';



export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const basicStore = useBasicStore();
const { userId, showVoteDialog, roomInfos }= storeToRefs(basicStore);

const voteDialog = ref(false);
const disabled = ref(false);
const show = ref(false);
const showup = ref(false);
const footershow = ref(false);
const footershows = ref(false);
const publishshow = ref(false);
const publisbtn=  ref(false)
const stopBtn= ref(false);
const resuliListshow=ref(false)
const colorIndex=ref()

const foomRef = ref<any>()
const publishRef = ref<any>()


watch(showVoteDialog, async (val : boolean) => {
  console.log("-----------------showVoteDialog--------------------")
  console.log(val)
  voteDialog.value = val;
  if (val){
    getVoteListArr();
  }
});

const voteList: any = ref([]);
const voteActivity: any = ref({});

/**
 * 显示样式
 */
async function addvotelist(){
  disabled.value = true;
  show.value = true;
  showup.value = false;
  footershow.value = true;
  footershows.value = false;
  publishshow.value = false;
  stopBtn.value=false
  publisbtn.value=false
   colorIndex.value=100
}
async function delVotoCancel(){
  disabled.value = false;
  show.value = false;
  showup.value = false;
  footershow.value = false;
  footershows.value = false;
  publishshow.value = false;
  resuliListshow.value=false
}

/**
 * 添加题目
 */
async  function  addsubject(){
    console.log("添加题目")
    foomRef.value.parentMsg()
}

//编辑
async  function  voteEdit(){
  publishRef.value.publishbtn()
  publisbtn.value=false
  footershow.value=true
}


//下载
async  function  exports(){

   exportAnalysisHooks(`https://${window.document.location.host}/api/live/vote/export`,voteActivity.value.id,)

  //  exportVote({
  //   voteId:voteActivity.value.id
  //  }).then(res=>{
  //   const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
  //     // const fileName = decodeURI(res.headers['content-disposition'])
  //     if ('download' in document.createElement('a')) {
  //       // 非IE下载
  //       const elink = document.createElement('a')
  //       // elink.download = fileName
  //       elink.style.display = 'none'
  //       elink.href = URL.createObjectURL(blob)
  //       document.body.appendChild(elink)
  //       elink.click()
  //       URL.revokeObjectURL(elink.href) // 释放URL 对象
  //       document.body.removeChild(elink)
  //     } else {
  //       // IE10+下载
  //       // navigator.msSaveBlob(blob, fileName)
  //     }
        
  //  }).catch(err=>{
  //   console.log(err);
    
  //  })
}

//保存
async function preserveBtn(){
    foomRef.value.preserve()
   
   setTimeout(() => {
     footershow.value=false
    show.value=false
    getVoteListArr()
    
   }, 1000);
}
    //发布
async function publishBtn(){
  // publishRef.value.publishbtn()
  let arr = {
        userId: userId.value,
        status: "publish_ing",
        voteId: voteActivity.value.id
    }
    editStatus(arr)
       .then(res => {
            console.log(res)
            if (res.code == "000") {
                Message({
                    type: 'success',
                    message: "发布成功",
                    duration: MESSAGE_DURATION.NORMAL,
                });
                publisbtn.value=false
                stopBtn.value=true
                resuliListshow.value=true
                publishshow.value=false
                colorIndex.value=0
                getVoteListArr()


            } else {
                Message({
                    type: 'warning',
                    message: res.msg,
                    duration: MESSAGE_DURATION.NORMAL,
                });
            }
        }).catch(err => {
            console.log(err)
        })
}
//获取投票列表
async function getVoteListArr() {
  let arr = {
    userId:userId.value,
    roomNo:roomInfos.value.roomId,
    status:roomInfos.value.roomStatus,
    pageNum:1,
    pageSize:20,
  };
  getVoteList(arr).then(res=>{
    console.log(res)
    if (res.code == "000"){

      voteList.value=res.data.data
    }else{
      Message({
        type: 'error',
        message: res.msg,
        duration: MESSAGE_DURATION.NORMAL,
      });
    }
  }).catch(err=>{
    console.log(err)
  })
}
const indexNum=ref()
//点击列表
async function resultClickVote(j:any,index:any){
  console.log(j);
  console.log(index);
  indexNum.value=index
  colorIndex.value=index
  if(j.status=="publish_ing"){
      stopBtn.value=true
      footershows.value=false
      publisbtn.value=false
      footershow.value=false
      resuliListshow.value=true
    publishshow.value=false
  }else if(j.status=="stop_publish"){
    footershows.value=true
    stopBtn.value=false
    publisbtn.value=false
    footershow.value=false
    resuliListshow.value=true
    publishshow.value=false
  }else if(j.status=="no_publish"){
    publisbtn.value=true
    stopBtn.value=false
    footershows.value=false
    footershow.value=false
    resuliListshow.value=false
    publishshow.value=true
  }
  voteActivity.value = j
  show.value = false
  showup.value = true

  disabled.value = false



}

//发布时删除投票
async function deletePublish(){
  deleteVote({id:voteActivity.value.id, userId:userId.value}).then(res=>{
    console.log(res)
    if(res.code=='000'){
      Message({
        type: 'success',
        message: '删除成功',
        duration: MESSAGE_DURATION.NORMAL,
      });
      resuliListshow.value=false
      footershows.value=false
      publisbtn.value=false
      publishshow.value=false
      getVoteListArr()
    }else{
      Message({
        type: 'error',
        message: res.msg,
        duration: MESSAGE_DURATION.NORMAL,
      });
    }
  }).catch(err=>{
    console.log(err)
  })
};

async  function updateVote(){
  console.log(userId.value);
  console.log(voteActivity.value.id);
  console.log(voteList.value);

  editStatus({userId:userId.value, status:"stop_publish", voteId:voteActivity.value.id}).then(res=>{
    console.log(res)
    if(res.code=='000'){
      Message({
        type: 'success',
        message: "停止成功",
        duration: MESSAGE_DURATION.NORMAL,
      });
       console.log('停止成功',res);
      voteActivity.value = res.data
      stopBtn.value=false
      footershows.value=true
      resuliListshow.value=true
      publishshow.value=false
      getVoteListArr()
    }else {
      Message({
        type: 'error',
        message: res.msg,
        duration: MESSAGE_DURATION.NORMAL,
      });
    }
  }).catch(err=>{
    console.log(err)
  })
}

async function morePublishBtn() {
  let arr = {
        userId: userId.value,
        status: "again_publish",
        voteId: voteActivity.value.id
    }
    editStatus(arr)
       .then(res => {
            console.log(res)
            if (res.code == "000") {
                Message({
                    type: 'success',
                    message: "再次发布成功",
                    duration: MESSAGE_DURATION.NORMAL,
                });
                // stopBtn.value=true
                 footershows.value=false
                resuliListshow.value=false
                colorIndex.value=100
                getVoteListArr()
            } else {
                Message({
                    type: 'warning',
                    message: res.msg,
                    duration: MESSAGE_DURATION.NORMAL,
                });
            }
        }).catch(err => {
            console.log(err)
        })

}

async  function   handleCloseSettingDialog() {
  basicStore.setShowVoteDialog(false);
}



return { __sfc: true,basicStore, userId, showVoteDialog, roomInfos, voteDialog, disabled, show, showup, footershow, footershows, publishshow, publisbtn, stopBtn, resuliListshow, colorIndex, foomRef, publishRef, voteList, voteActivity, addvotelist, delVotoCancel, addsubject, voteEdit, exports, preserveBtn, publishBtn, getVoteListArr, indexNum, resultClickVote, deletePublish, updateVote, morePublishBtn, handleCloseSettingDialog, SvgIcon, Foom, ResuliList, Publish }
}

})